import React, { useMemo } from 'react';
import StreamingGridView from './StreamingGridView';

const StreamingBySectionView = ({ content, reportId, excludedContentIds = [], onContentExcluded, sortBy = 'avgCcv-high', onSortChange }) => {
  // Filter out excluded content first, then group by platform
  const groupedByPlatform = useMemo(() => {
    const groups = {};

    // Filter out excluded content
    const filteredContent = content.filter(stream => !excludedContentIds.includes(stream.id));

    filteredContent.forEach(stream => {
      const platform = stream.platform?.toLowerCase() || 'other';
      if (!groups[platform]) {
        groups[platform] = [];
      }
      groups[platform].push(stream);
    });

    return groups;
  }, [content, excludedContentIds]);

  // Define platform display order - Twitch first for visibility
  const platformOrder = ['twitch', 'youtube', 'kick'];
  const platformLabels = {
    youtube: 'YouTube Streams',
    tiktok: 'TikTok Streams',
    twitch: 'Twitch Streams',
    kick: 'Kick Streams',
    other: 'Other Platform Streams'
  };

  // Get platforms in order, filter to only those with content
  const platformsToShow = platformOrder.filter(p => groupedByPlatform[p]?.length > 0);

  return (
    <div className="space-y-6">
      {platformsToShow.map(platform => (
        <div key={platform} className="space-y-2">
          {/* Compact Platform Header */}
          <div className="flex items-center justify-between bg-gray-900 px-4 py-2 rounded-lg border border-white">
            <h3 className="text-sm font-semibold text-white">
              {platformLabels[platform] || `${platform.charAt(0).toUpperCase() + platform.slice(1)} Streams`}
            </h3>
            <span className="text-xs font-medium text-white bg-white/10 px-2 py-1 rounded">
              {groupedByPlatform[platform].length} stream{groupedByPlatform[platform].length !== 1 ? 's' : ''}
            </span>
          </div>

          {/* Streaming Grid for this platform */}
          <StreamingGridView
            content={groupedByPlatform[platform]}
            reportId={reportId}
            excludedContentIds={excludedContentIds}
            onContentExcluded={onContentExcluded}
            sortBy={sortBy}
            onSortChange={onSortChange}
          />
        </div>
      ))}
    </div>
  );
};

export default StreamingBySectionView;
